class ToggleJsonBlock extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false,
    };
  };

  toggleDetails() {
    const showDetails = !this.state.showDetails
    this.setState({
      showDetails: showDetails
    })
  }

  render() {
    return (<div>
          <div>
            <button onClick={this.toggleDetails.bind(this)}>{this.state.showDetails ? 'Hide' : 'Show'}</button>
            {this.state.showDetails ?
                <div>
                  <pre>{JSON.stringify(this.props, null, 4)}</pre>
                </div> : ''}
          </div>
        </div>
    )
  }
}


class VettingReviewsStatusFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "pending": {
        "title": "Pending",
        "icon": "clock text-info",
        "selected": this.props.defaultToPending
      },
      "approved": {
        "title": "Approved",
        "icon": "check-circle text-success",
        "selected": false
      },
      "approved_with_edd": {
        "title": "Approved with EDD",
        "icon": "check-circle text-warning",
        "selected": false
      },
      "rejected": {
        "title": "Rejected",
        "icon": "minus-3 text-danger",
        "selected": false
      },
      "expired": {
        "title": "Expired",
        "icon": "delete-3 text-warning",
        "selected": false
      },
    }
  }
}

VettingReviewsStatusFilter.defaultProps = {
  "emptySelectedString": "All statuses",
  "filterKey": "status",
  "filterIcon": "icon-streamline-sync"
};

class VettingReviewsTypeFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "match": {
        "title": "MATCH",
        "selected": false
      },
      "name_validation": {
        "title": "Name Validation",
        "selected": false
      },
      "watchlist": {
        "title": "Watchlist",
        "selected": false
      },
    }
  }
}

VettingReviewsTypeFilter.defaultProps = {
  "emptySelectedString": "All types",
  "filterKey": "type",
  "filterIcon": "icon-bookmark-1"
};

class VettingReviewsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return <waffle.blocks.FilterBlock>
      <VettingReviewsStatusFilter defaultToPending={this.props.defaultToPending} />
      <VettingReviewsTypeFilter />
    </waffle.blocks.FilterBlock>
  }
}

class VettingTaskTypeFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "cipc": {
        "title": "CIPC",
        "selected": false
      },
      "blocklist": {
        "title": "Blocklist",
        "selected": false
      },
      "match": {
        "title": "MATCH",
        "selected": false
      },
      "consumer_credit_check": {
        "title": "Consumer Credit Check",
        "selected": false
      },
      "name_validation": {
        "title": "Name Validation",
        "selected": false
      },
      "watchlist": {
        "title": "Watchlist",
        "selected": false
      },
    }
  }
}

VettingTaskTypeFilter.defaultProps = {
  "emptySelectedString": "All types",
  "filterKey": "type",
  "filterIcon": "icon-bookmark-1"
};

class VettingTaskStatusFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "successful": {
        "title": "Successful",
        "icon": "check-circle text-success",
        "selected": false
      },
      "failed": {
        "title": "Failed",
        "icon": "minus-3 text-danger",
        "selected": false
      },
      "skipped": {
        "title": "Skipped",
        "icon": "check-circle text-warning",
        "selected": false
      },
    }
  }
}

VettingTaskStatusFilter.defaultProps = {
  "emptySelectedString": "All statuses",
  "filterKey": "status",
  "filterIcon": "icon-streamline-sync"
};

class VettingTaskResultsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return <waffle.blocks.FilterBlock>
      <VettingTaskStatusFilter />
      <VettingTaskTypeFilter />
    </waffle.blocks.FilterBlock>
  }
}

class VettingTaskLink extends waffle.base.BaseComponent {
  render() {
    return <a href={`/businesses/${this.props.business_uuid}/vetting/${this.props?.uuid || this.props.type}/`}>View</a>
  }
}


module.exports = {
  VettingReviewsFilterBlock,
  VettingTaskResultsFilterBlock,
  ToggleJsonBlock,
  VettingTaskLink,
};
